<template>
	<div v-if="loading">
		<LoadingSpinner :message="$t('lang.views.families.data_loading')" />
	</div>
	<div v-else>
		<Search
			:title="'Etiquetas'"
			:btnLabel="'Nueva etiqueta'"
			:defaultValue="''"
			goTo="/createTag"
			@searchEvent="searchTags"
		/>
		<TagsCardList :tags="tagsCollection" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Search from '@/components/Search.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import TagsCardList from './components/TagsCardList.vue';

export default {
	name: 'Tags',

	components: { TagsCardList, LoadingSpinner, Search },

	data: () => ({
		tags: [],
		tagsCollection: [],
		loading: true
	}),

	async mounted() {
		try {
			this.tags = this.tagsCollection = await this.getTags();
		} catch (error) {
			console.log(error);
		} finally {
			this.loading = false;
		}
	},

	methods: {
		...mapActions('tagsStore', ['getTags']),

		searchTags(value) {
			try {
				this.loading = true;
				let stringToSearch = value.toLowerCase().trim();
				this.tagsCollection = stringToSearch.length
					? this.tags.filter(
							(x) => x.name.toLowerCase().trim().includes(stringToSearch)
							// eslint-disable-next-line no-mixed-spaces-and-tabs
					  )
					: [...this.tags];
				// this.$mixpanel.track('Search in family', { stringToSearch });
			} catch (error) {
				console.log(error);
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>
